import { type FormEvent, useState } from 'react'
import { ArrowRight, KeyRound, RefreshCw, ShieldCheck } from 'lucide-react'
import { api, clearCredentials } from '../lib/api'
import type { Session } from '../types'
import { FeishuOauthLink } from './FeishuOauthLink'

export function FeishuOperationPasswordSetup({ session, returnTo = '/feishu' }: {
  session: Session
  returnTo?: string
}) {
  const [newPassword, setNewPassword] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const loginUrl = `/api/integrations/feishu/login?returnTo=${encodeURIComponent(returnTo)}`

  async function submit(event: FormEvent) {
    event.preventDefault()
    if (newPassword !== confirmation) { setError('两次输入的登录密码不一致'); return }
    setSaving(true); setError('')
    try {
      await api.setFeishuOperationPassword(newPassword)
      clearCredentials()
      window.location.assign(loginUrl)
    } catch (value) {
      setError(value instanceof Error ? value.message : '登录密码设置失败')
    } finally { setSaving(false) }
  }

  return <main className="feishu-workbench feishu-operation-onboarding">
    <section className="feishu-operation-card" aria-labelledby="feishu-operation-title">
      <span className="feishu-operation-icon"><KeyRound size={27} /></span>
      <small>FEISHU SECURITY ONBOARDING</small>
      <h1 id="feishu-operation-title">设置你的 License Center 登录密码</h1>
      <p>账号 <b>{session.username}</b> 已通过飞书企业身份验证。请设置个人登录密码，之后可用飞书身份或该密码登录 License Center。</p>
      {session.operationPasswordSetupAllowed ? <>
        <div className="feishu-operation-trust"><ShieldCheck size={18} /><div><b>无需管理员临时密码</b><span>本入口只在刚完成飞书 OAuth 且绑定有效时开放 10 分钟。新密码只提交给 License Center，不会发送给飞书。</span></div></div>
        <form onSubmit={submit}>
          <label>新登录密码<input type="password" value={newPassword} onChange={event => setNewPassword(event.target.value)} autoFocus autoComplete="new-password" minLength={8} maxLength={72} required /></label>
          <label>确认登录密码<input type="password" value={confirmation} onChange={event => setConfirmation(event.target.value)} autoComplete="new-password" minLength={8} maxLength={72} required /></label>
          <small className="feishu-operation-policy">至少 8 位，同时包含大写字母、小写字母、数字和特殊字符；不能包含登录账号或使用常见弱密码。</small>
          {error && <div className="form-error">{error}</div>}
          <button className="button button--primary" disabled={saving}>{saving ? '正在安全设置...' : '设置并重新通过飞书进入'}<ArrowRight size={17} /></button>
        </form>
      </> : <div className="feishu-operation-expired"><RefreshCw size={21} /><div><b>本次飞书身份确认已超时</b><p>请重新通过飞书验证。验证成功后会回到这里继续设置，不需要联系管理员索取临时密码。</p><FeishuOauthLink className="button button--primary" href={loginUrl}>重新通过飞书验证<ArrowRight size={17} /></FeishuOauthLink></div></div>}
      <footer>设置完成会撤销旧会话。新密码仅用于账号登录，不影响业务岗位权限和审批流程。</footer>
    </section>
  </main>
}
